import { motion } from "framer-motion";
import { useSiteImages } from "@/hooks/useSiteImages";

export const GuidingInfluence = () => {
  const imgs = useSiteImages();
  return (
    <section data-testid="guiding-influence-section" className="py-24 md:py-32 lg:py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">
              Our Guiding Influence
            </p>
            <h1
              data-testid="guiding-influence-heading"
              className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-bold text-[#1D1D1F]"
            >
              A bird that only drinks from the sky.
            </h1>
            <div className="mt-8 space-y-5 text-lg leading-relaxed text-[#86868B]">
              <p>
                Meet the extraordinary <span className="text-[#1D1D1F] font-medium">Jacobin Cuckoo</span> — a
                one-of-a-kind bird on our planet.
              </p>
              <p>
                Its specialty is remarkable: it drinks only falling raindrops, straight from the clouds. No
                matter how thirsty it gets, it will not drink any other kind of water.
              </p>
              <p className="text-[#1D1D1F] font-medium">
                We believe the Jacobin Cuckoo would happily drink our water too.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 1.04 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="rounded-3xl overflow-hidden bg-[#F5F5F7] relative"
          >
            <img
              src={imgs.vision_kingfisher}
              alt="The Jacobin Cuckoo — Nyla's guiding influence"
              decoding="async"
              className="w-full h-[420px] md:h-[560px] object-contain"
            />
            <p className="absolute bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap text-[11px] tracking-[0.2em] uppercase font-semibold text-[#1D1D1F]/70 bg-white/80 backdrop-blur-md px-4 py-2 rounded-full">
              The Jacobin Cuckoo — Nature's Purist
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
